'use client';

import { useTranslations } from '@dealerportal/i18n/client';
import { useProductSearchBox } from '@dealerportal/react-helpers';
import { isFalsyString } from '@dealerportal/utilities';
import { useEffect, useState } from 'react';
import { BetterButton } from './BetterButton';

type Props = {
  id: string;
  title: string;
  hidekeyboardshortcut: string;
  isMobileDevice: boolean;
  imgSrc?: string;
};

export function ProductSearchBox(props: Props) {
  const ctx = useProductSearchBox();
  const t = useTranslations('products');
  const tCommon = useTranslations('common');

  useEffect(() => {
    if (!ctx?.available) {
      ctx?.setAvailable(true);
    }
  }, [ctx]);

  const [keyboardShortCut, setKeyboardShortCut] = useState('');

  useEffect(() => {
    if (window.navigator.userAgent.toLowerCase().includes('mac')) {
      setKeyboardShortCut('⌘K');
      return;
    }

    if (window.navigator.userAgent.toLowerCase().includes('windows')) {
      setKeyboardShortCut('Ctrl K');
      return;
    }
  }, []);

  return (
    <>
      <div className="ui-hidden md:ui-block">
        <BetterButton
          label={`<span>${props.title || t('searchProducts')}</span> ${
            isFalsyString(props.hidekeyboardshortcut) ? keyboardShortCut : ''
          }`}
          labelClassName="ui-flex-1 ui-flex ui-justify-between ui-gap-4 ui-text-xs"
          btnStyle="neutral"
          icon='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path class="ui-fill-gray-500" d="M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z" /></svg>'
          iconSize="4"
          attributes={{
            type: 'button',
            onClick: () => ctx?.open(),
            'data-cic-intent': '',
          }}
          className="ui-h-9 !ui-rounded-md"
          replaceClass={{
            '!ui-w-max': '!ui-w-full',
            '!ui-px-6': '!ui-px-3 !ui-pr-4',
            '!ui-text-sm': '!ui-text-xs',
            '!ui-text-gray-950': '!ui-text-gray-500',
            '!ui-border-gray-700': '!ui-border-gray-400',
          }}
        />
      </div>

      <div
        className="ui-block sm:ui-hidden"
        onClick={() => ctx?.open()}
        onKeyDown={(_e) => {}}
        role="button"
        tabIndex={0}
        data-cic-intent=""
      >
        <img
          alt={tCommon('search')}
          className="md:ui-hidden"
          loading="lazy"
          width="32"
          height="32"
          decoding="async"
          style={{
            color: 'transparent',
            maxWidth: '100%',
            maxHeight: '100%',
            height: 'auto',
          }}
          src={
            props?.imgSrc && props?.imgSrc !== ''
              ? props.imgSrc
              : 'https://res.cloudinary.com/force/image/upload/f_auto,q_auto,w_32,h_32/c_limit,w_32/v1518471186/icons/icon_search2?_a=BAVAS1E60'
          }
        />
      </div>
    </>
  );
}

export default ProductSearchBox;
